import {
	Box,
	ClickAwayListener,
	Paper,
	Popover,
	styled,
	Tabs,
} from "@mui/material";
import { Button } from "@samdesk/components/Button";
import { Tooltip } from "@samdesk/components/Tooltip";
import { DashboardTab } from "api/queries/useGetDashboard";
import { useState } from "react";
import theme from "theme";
import Tab from "./Tab";

export interface SeeAllTabProps {
	tabs: DashboardTab[];
	currentTabIndex: number;
}

export const SeeAllTab = ({ tabs, currentTabIndex }: SeeAllTabProps) => {
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
	const [openPopover, setOpenPopover] = useState(false);

	const isValidTabIndex = currentTabIndex >= 0 && currentTabIndex < tabs.length;

	return (
		<>
			<Tooltip text="See all tabs">
				<Button
					prominence="tertiary"
					label="See all tabs"
					onClick={(e) => {
						setAnchorEl(e.currentTarget);
						setOpenPopover(true);
					}}
					icon="tabs"
					asIcon
				/>
			</Tooltip>

			<Popover
				slots={{ paper: SeeAllTabsPaper }}
				anchorEl={anchorEl}
				anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
				open={openPopover}
			>
				<ClickAwayListener onClickAway={() => setOpenPopover(false)}>
					<Box>
						<Tabs
							TabIndicatorProps={tabIndicatorProps}
							orientation="vertical"
							sx={tabsContainerSx}
							value={isValidTabIndex ? currentTabIndex : false}
						>
							{tabs.map((tab, index) => (
								<Tab
									isCurrentTab={currentTabIndex === index}
									isOverflowComponent={true}
									key={tab.key}
									tab={tab}
								/>
							))}
						</Tabs>
					</Box>
				</ClickAwayListener>
			</Popover>
		</>
	);
};

const SeeAllTabsPaper = styled(Paper)({
	position: "absolute",
	overflowX: "hidden",
	overflowY: "auto",
	minWidth: 16,
	minHeight: 16,
	maxWidth: "calc(100% - 32px)",
	outline: 0,
	border: `1px solid ${theme.palette.border.main}`,
	height: "fit-content",
	maxHeight: "75vh",
	marginLeft: "-25px",
	marginTop: "25px",
});

const tabsContainerSx = {
	"& .MuiTabs-flexContainer": {
		alignItems: "flex-end",
		height: "fit-content",
	},
};

const tabIndicatorProps = {
	style: { display: "none" },
};
